import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import './styles/Global.css';
import './styles/Utils.css';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function InstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!visible || !prompt) return null;

  const install = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setVisible(false);
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 99999,
      background: '#1e1b4b', color: '#fff',
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '12px 16px',
      boxShadow: '0 -2px 16px rgba(0,0,0,0.3)',
      fontFamily: 'system-ui, sans-serif', fontSize: 14,
    }}>
      <span style={{ fontSize: 22 }}>📲</span>
      <span style={{ flex: 1, lineHeight: 1.4 }}>
        <strong>Instalar BDA&gt;&gt; Atendimentos</strong><br />
        <span style={{ opacity: 0.8, fontSize: 12 }}>Adicione à tela inicial para acesso rápido</span>
      </span>
      <button onClick={install} style={{
        background: '#4F46E5', color: '#fff', border: 'none',
        borderRadius: 8, padding: '8px 18px', fontWeight: 600,
        cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap',
      }}>
        Instalar
      </button>
      <button onClick={() => setVisible(false)} style={{
        background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.6)',
        cursor: 'pointer', fontSize: 20, lineHeight: 1, padding: '0 4px',
      }}>
        ×
      </button>
    </div>
  );
}

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
      <InstallBanner />
    </>
  );
}

export default App;
